import { getParams, handleResponse } from "../helpers/validate";
import { SCHOOL_URL_V2 } from "../helpers/routes";
import notice from "../../utils/notice";

export const saveNotification = (data, slug) => {
  let teamsId = [];
  let studentsId = [];
  if (data.teams_id.length > 0) {
    teamsId = data.teams_id.map((team) => team.id);
  }
  if (data.students_id.length > 0) {
    studentsId = data.students_id.map((student) => student.id);
  }

  const newData = {
    ...data,
    teams_id: teamsId,
    students_id: studentsId,
  };

  const jsonData = JSON.stringify(newData);
  return fetch(
    `${SCHOOL_URL_V2}/${slug}/push_notification`,
    getParams("POST", jsonData)
  )
    .then((res) => handleResponse(res))
    .then((json) => notice("Notification created", "success"))
    .catch((e) => {
      notice("Error saving the notification");
      console.error(e.errors);
      throw e;
    });
};
